module.exports = __webpack_public_path__ + "img/logo10.027280ca.png";